import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObtenerNumeroUsuariosService {

  private readonly dashboardUrl: string;

  constructor(private httpClient: HttpClient) {
    this.dashboardUrl = environment.apiUrl + '/administrador/dashboard/numero-usuarios';
  }

  public __invoke(): Observable<number> {
    return this.httpClient.get<number>(this.dashboardUrl);
  }
}
